import $ from "jquery";
import BD_Block from "@bd-core/bd-block";
import Store_SequenceHistory from "@bd-components/store-sequence-history";
import BD_GAME_LOGIC from "@bd-core/game-logic";
import { compile } from "@bd-utils/handlerbars-helper";
import videojs from "video.js";
export class Block_Video extends BD_Block {
  constructor() {
    super();

    this.type = "video";
    this.templateID = "video-template";

    this.elms = {
      playBtn: ".js-play",
      pauseBtn: ".js-pause",
      questionCard: ".questionCard",
      questionCardV2: ".v2-questionCard",
      questionCardV3: ".v3-questionCard",
      questionModal: ".question-modal",
      answer: ".js-answer",
      submit: ".js-submit",
      video: "#js-fullscreen-video",
      backWrapper: ".questionCard__back",
      back: ".js-back",
    };

    this._events = this.getEvents();

    /* custom attributes */
    this.video = null;
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "click",
        selector: elms.playBtn,
        handler: this.onPlayVideo,
      },
      {
        event: "click",
        selector: elms.pauseBtn,
        handler: this.onPauseVideo,
      },
      {
        event: "click",
        selector: elms.back,
        handler: this.back,
      },
    ];
  }

  beforeInit() {
    this.render();
    this.setGameState();
    this.setupVideo();
  }

  render() {
    const htmlTemplate = $("#" + this.templateID).html();

    const html = compile(htmlTemplate, this._data);
    $("#templateWrapper").html(html);

    $(".gameScreen").addClass("v3-questionCard");
  }

  setupVideo() {
    const _this = this;
    const elms = this.elms;
    const $elVideo = $(elms.video);
    const isShowControls = this._data.is_display_controls;

    if ($elVideo.length < 0) {
      return false;
    }

    this.video = videojs($elVideo.attr("id"), {
      controls: isShowControls,
      autoplay: true,
      preload: "auto",
    });

    // TODO change to video can play throu
    _this.video.ready(function () {
      //set default style of subtitle
      // @ts-ignore
      const settings = this.textTrackSettings;

      settings.setValues({
        backgroundOpacity: "0",
        edgeStyle: "dropshadow",
      });

      settings.updateDisplay();
    });

    this.video.on("play", () => {
      $(".gameScreen").addClass("videoPlaying");
    });

    this.video.on("ended", () => {
      BD_GAME_LOGIC.continueTimer();
      const isSkipNextButton = this._data.is_skip_next_button;
      if (isSkipNextButton) {
        BD_GAME_LOGIC.goToDefaultNextBlock();
      }
    });

    this.video.on("error", (error) => {
      BD_GAME_LOGIC.continueTimer();
      console.error("Video error", error);
    });

    try {
      BD_GAME_LOGIC.pauseTimer();
      this.video.play().catch((error) => {
        console.error("Unable to start auto play", error);
      });
    } catch (error) {
      console.error(error);
    }
  }

  setGameState() {
    const showBackBtn = () => {
      if (Store_SequenceHistory.data) {
        $(this.elms.backWrapper).addClass("is-active");
      }
    };

    showBackBtn();
  }

  /* ========= ELEMENT FUNCTION HANDLER ===============*/
  onPlayVideo(e) {
    if (e) e.preventDefault();
    const _this = this;

    _this.video
      .play()
      .then(() => {
        $(".gameScreen").addClass("videoPlaying");
      })
      .catch(() => {
        // Autoplay was blocked. Do something
      });
  }

  onPauseVideo(e) {
    if (e) e.preventDefault();
    const _this = this;
    if (!_this.video.paused()) {
      _this.video.pause();
      $(".gameScreen").removeClass("videoPlaying");
    }
  }

  back() {
    const seqHistory = Store_SequenceHistory.data;
    const currentBlockID = parseInt(BD_GAME_LOGIC.getCurrentBlockID());
    const history = seqHistory[currentBlockID];
    if (!history) return;

    BD_GAME_LOGIC.goBack(history.prev);
  }

  beforeDestroy() {
    if (this.video) {
      this.video.dispose();
    }
  }
}
